import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'bulk_upload_review',
  templateUrl: './bulk_upload_review.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryBulkUploadReviewComponent implements OnInit {
  @Input() data;

  @Output() moveNextPreviousEvent = new EventEmitter<any>();

  ngOnInit(): void {}

  save() {
    this.moveNextPreviousEvent.emit({ status: 'forward', id: this.data.id });
  }

  back() {
    this.moveNextPreviousEvent.emit({ status: 'backward' });
  }
}
